import React from 'react';

import Base from './Base.jsx';

import ProductForm from '../Components/ProductForm/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs:product-form';
  }

  renderElement(element) {
    var currentProductId = parseInt(element.dataset.currentProductId);
    var currency = element.dataset.currency;
    var tiers = element.dataset.tiers;
    if (tiers) {
      tiers = JSON.parse(tiers);
    }

    return (
      <ProductForm
        tiers={tiers}
        currentProductId={currentProductId}
        currency={currency}
      />
    );
  }
}


export default EntryPoint;

